(function () {
  'use strict';

  var VERSION = '1.2.0-native-compact-preset';
  var PRODUCT_PATH = '/products/custom-infinity-mirror';
  var SIZE_MODE_CATEGORY_ID = 'LB4oi7z56Ta0OZehKxWNh6o0';
  var PRESET_OPTION_ID = 'ChhzZNLNHc6HoBDjegeEYT4G';
  var SIZE_UNIT_CATEGORY_ID = 'SAvhX7xAkC66xUbZf1toKKOW';
  var CUSTOM_CATEGORY_IDS = [
    'dbIF9OR5ZazT43lgZsJxGlfh',
    'aE4hNil-ULOoL_nuXhFekRZl'
  ];
  var PRESET_CATEGORY_IDS = [
    'Zs0mISKbbkrsanNymAIa6Zqf',
    'CQ5DSHGSBYKcjbeq1b8rf7MU'
  ];
  var SIGNATURE_NAMES = ['Compact', 'Classic', 'Statement', 'Gallery', 'Feature', 'Grand'];
  var SQUARE_DIMENSIONS = [18, 24, 36, 48, 60, 72];
  var RECTANGLE_DIMENSIONS = [
    [18, 9],
    [24, 12],
    [36, 18],
    [48, 24],
    [60, 30],
    [72, 36]
  ];

  if (window.__MAYTRIX_SIGNATURE_SIZES__) return;

  function onTargetProduct() {
    return window.location.pathname === PRODUCT_PATH && !!document.getElementById('product-builder');
  }

  function directLabel(option) {
    if (!option) return null;
    for (var index = 0; index < option.children.length; index += 1) {
      var child = option.children[index];
      if (child.tagName === 'DIV' && !child.classList.contains('cpb-option-description')) return child;
    }
    return null;
  }

  function canonicalShape(value) {
    var token = String(value == null ? '' : value)
      .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
    if (/^(?:arch|tombstone|arch tombstone)$/.test(token)) return 'arch';
    if (/^(?:octagon|octagonal)$/.test(token)) return 'octagon';
    if (/^(?:landscape|landscape rectangle|horizontal rectangle|rectangle|rect)$/.test(token)) return 'rectangle';
    if (/^(?:portrait|portrait rectangle|vertical rectangle|vrect)$/.test(token)) return 'vrect';
    if (/^(?:oval horizontal|horizontal oval|capsule horizontal|horizontal capsule|hoval)$/.test(token)) return 'hoval';
    if (/^(?:oval vertical|vertical oval|capsule vertical|vertical capsule|voval)$/.test(token)) return 'voval';
    if (token === 'round') return 'circle';
    if (token === 'circle' || token === 'square') return token;
    return 'square';
  }

  function isSquareFamily(shape) {
    return /^(?:square|circle|octagon)$/.test(canonicalShape(shape));
  }

  function isPortraitFamily(shape) {
    return /^(?:vrect|voval|arch)$/.test(canonicalShape(shape));
  }

  function categoryIdForShape(shape) {
    return isSquareFamily(shape) ? PRESET_CATEGORY_IDS[0] : PRESET_CATEGORY_IDS[1];
  }

  function compact(number) {
    return String(parseFloat(Number(number).toFixed(1)));
  }

  function choiceLabel(width, height) {
    return compact(width) + ' × ' + compact(height) + ' in';
  }

  function fallbackChoices(shape) {
    var square = isSquareFamily(shape);
    var portrait = isPortraitFamily(shape);
    return SIGNATURE_NAMES.map(function (name, index) {
      var width;
      var height;
      if (square) {
        width = height = SQUARE_DIMENSIONS[index];
      } else {
        width = RECTANGLE_DIMENSIONS[index][0];
        height = RECTANGLE_DIMENSIONS[index][1];
        if (portrait) {
          var temporaryWidth = width;
          width = height;
          height = temporaryWidth;
        }
      }
      return {
        name: name,
        width: width,
        height: height,
        unit: 'in',
        label: choiceLabel(width, height),
        optionId: ''
      };
    });
  }

  function cardChoice(card, shape) {
    if (!card) return null;
    var labelNode = directLabel(card);
    var text = String(labelNode ? labelNode.textContent : card.textContent || '').replace(/\s+/g, ' ').trim();
    var name = SIGNATURE_NAMES.find(function (candidate) { return text.indexOf(candidate) !== -1; }) || '';
    var numbers = text.match(/\d+(?:\.\d+)?/g) || [];
    if (!name || !numbers.length) return null;
    var width = parseFloat(numbers[0]);
    var height = numbers.length > 1 ? parseFloat(numbers[1]) : width;
    if (isSquareFamily(shape)) {
      width = height = Math.max(width, height);
    } else if (isPortraitFamily(shape) && width > height) {
      var portraitWidth = height;
      height = width;
      width = portraitWidth;
    } else if (!isPortraitFamily(shape) && width < height) {
      var landscapeWidth = height;
      height = width;
      width = landscapeWidth;
    }
    return {
      name: name,
      width: width,
      height: height,
      unit: 'in',
      label: choiceLabel(width, height),
      optionId: card.getAttribute('data-option-id') || ''
    };
  }

  function mountedChoices(shape) {
    var category = document.querySelector('[data-category-id="' + categoryIdForShape(shape) + '"]');
    if (!category) return [];
    return Array.prototype.map.call(category.querySelectorAll('[role="button"][data-option-id]'), function (card) {
      return cardChoice(card, shape);
    }).filter(Boolean);
  }

  function getChoices(shape) {
    var live = mountedChoices(shape);
    if (!live.length) return fallbackChoices(shape);
    var byName = {};
    live.forEach(function (choice) { byName[choice.name] = choice; });
    return fallbackChoices(shape).map(function (fallback) {
      return byName[fallback.name] || fallback;
    });
  }

  function selectedCard(shape) {
    var category = document.querySelector('[data-category-id="' + categoryIdForShape(shape) + '"]');
    return category && category.querySelector('[role="button"][data-option-id].cpb-active,[role="button"][data-option-id][aria-pressed="true"]');
  }

  function getSelection(shape) {
    return cardChoice(selectedCard(shape), shape);
  }

  function signatureModeButton() {
    var category = document.querySelector('[data-category-id="' + SIZE_MODE_CATEGORY_ID + '"]');
    return category && category.querySelector('[data-option-id="' + PRESET_OPTION_ID + '"]');
  }

  function activeOption(categoryId) {
    var category = document.querySelector('[data-category-id="' + categoryId + '"]');
    return category && category.querySelector('[role="button"][data-option-id].cpb-active,[role="button"][data-option-id][aria-pressed="true"]');
  }

  function isActiveOption(option) {
    return !!option && (option.classList.contains('cpb-active') || option.getAttribute('aria-pressed') === 'true');
  }

  function findChoiceCard(choice, shape) {
    var category = document.querySelector('[data-category-id="' + categoryIdForShape(shape) + '"]');
    var target = null;
    if (!category) return null;
    Array.prototype.some.call(category.querySelectorAll('[role="button"][data-option-id]'), function (card) {
      var candidate = cardChoice(card, shape);
      if ((choice.optionId && card.getAttribute('data-option-id') === choice.optionId) || sameChoice(candidate, choice)) {
        target = card;
        return true;
      }
      return false;
    });
    return target;
  }

  function customControlSnapshot() {
    var unit = activeOption(SIZE_UNIT_CATEGORY_ID);
    var state = {
      unitOptionId: unit && unit.getAttribute('data-option-id') || '',
      categoryId: '',
      values: []
    };
    CUSTOM_CATEGORY_IDS.some(function (categoryId) {
      var category = document.querySelector('[data-category-id="' + categoryId + '"]');
      var inputs = category && category.querySelectorAll('input[type="number"]');
      if (!inputs || inputs.length < 2) return false;
      state.categoryId = categoryId;
      state.values = Array.prototype.map.call(inputs, function (input) { return input.value; });
      return true;
    });
    return state;
  }

  function commitSnapshot(shape) {
    var mode = activeOption(SIZE_MODE_CATEGORY_ID);
    return {
      modeOptionId: mode && mode.getAttribute('data-option-id') || '',
      presetChoice: getSelection(shape),
      custom: customControlSnapshot()
    };
  }

  function setControlValue(input, value) {
    if (!input || value == null || input.value === String(value)) return;
    input.value = String(value);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  async function restoreCommitSnapshot(snapshot, shape) {
    if (!snapshot || !snapshot.modeOptionId) throw new Error('The previous size mode could not be identified.');
    var modeCategory = document.querySelector('[data-category-id="' + SIZE_MODE_CATEGORY_ID + '"]');
    var priorMode = modeCategory && modeCategory.querySelector('[data-option-id="' + snapshot.modeOptionId + '"]');
    if (!priorMode) throw new Error('The previous size mode is no longer available.');
    if (!isActiveOption(priorMode)) priorMode.click();
    await waitFor(function () {
      var active = activeOption(SIZE_MODE_CATEGORY_ID);
      return active && active.getAttribute('data-option-id') === snapshot.modeOptionId;
    }, 7000);

    if (snapshot.modeOptionId === PRESET_OPTION_ID && snapshot.presetChoice) {
      var priorChoice = await waitFor(function () {
        return findChoiceCard(snapshot.presetChoice, shape);
      }, 7000);
      if (!isActiveOption(priorChoice)) priorChoice.click();
      await waitFor(function () {
        return sameChoice(getSelection(shape), snapshot.presetChoice);
      }, 9000);
    } else if (snapshot.custom) {
      if (snapshot.custom.unitOptionId) {
        var unitCategory = document.querySelector('[data-category-id="' + SIZE_UNIT_CATEGORY_ID + '"]');
        var priorUnit = unitCategory && unitCategory.querySelector('[data-option-id="' + snapshot.custom.unitOptionId + '"]');
        if (priorUnit && !isActiveOption(priorUnit)) priorUnit.click();
        await waitFor(function () {
          var activeUnit = activeOption(SIZE_UNIT_CATEGORY_ID);
          return !priorUnit || (activeUnit && activeUnit.getAttribute('data-option-id') === snapshot.custom.unitOptionId);
        }, 7000);
      }
      if (snapshot.custom.categoryId && snapshot.custom.values.length) {
        var customCategory = await waitFor(function () {
          return document.querySelector('[data-category-id="' + snapshot.custom.categoryId + '"]');
        }, 7000);
        var inputs = customCategory.querySelectorAll('input[type="number"]');
        snapshot.custom.values.forEach(function (value, index) { setControlValue(inputs[index], value); });
        await waitFor(function () {
          var currentCategory = document.querySelector('[data-category-id="' + snapshot.custom.categoryId + '"]');
          var currentInputs = currentCategory && currentCategory.querySelectorAll('input[type="number"]');
          return currentInputs && snapshot.custom.values.every(function (value, index) {
            return currentInputs[index] && currentInputs[index].value === String(value);
          });
        }, 7000);
      }
    }
    await new Promise(function (resolve) { window.setTimeout(resolve, 320); });
  }

  function waitFor(test, timeoutMs) {
    var startedAt = Date.now();
    return new Promise(function (resolve, reject) {
      function check() {
        var result = false;
        try { result = test(); } catch (error) { /* the customizer may be between renders */ }
        if (result) {
          resolve(result);
          return;
        }
        if (Date.now() - startedAt >= timeoutMs) {
          reject(new Error('The customizer did not finish updating the selected size.'));
          return;
        }
        window.setTimeout(check, 80);
      }
      check();
    });
  }

  function sameChoice(left, right) {
    if (!left || !right) return false;
    return left.name === right.name || (Math.abs(left.width - right.width) < 0.1 && Math.abs(left.height - right.height) < 0.1);
  }

  async function commit(choice, shape) {
    if (!choice) throw new Error('Choose a Signature Size before applying it.');
    var snapshot = commitSnapshot(shape);
    try {
      var modeButton = signatureModeButton();
      if (!modeButton) throw new Error('Signature Sizes are not available yet.');
      if (!isActiveOption(modeButton)) modeButton.click();
      await waitFor(function () {
        var activeMode = activeOption(SIZE_MODE_CATEGORY_ID);
        return activeMode && activeMode.getAttribute('data-option-id') === PRESET_OPTION_ID && !!document.querySelector('[data-category-id="' + categoryIdForShape(shape) + '"]');
      }, 7000);
      var target = await waitFor(function () {
        var candidate = findChoiceCard(choice, shape);
        return candidate && candidate.isConnected ? candidate : false;
      }, 7000);
      if (!isActiveOption(target)) target.click();
      var selected = await waitFor(function () {
        var activeChoice = getSelection(shape);
        return sameChoice(activeChoice, choice) ? activeChoice : false;
      }, 9000);
      await new Promise(function (resolve) { window.setTimeout(resolve, 520); });
      var settledSelection = getSelection(shape);
      if (!sameChoice(settledSelection, choice)) throw new Error('The selected size did not remain applied.');
      return settledSelection || selected;
    } catch (error) {
      try {
        await restoreCommitSnapshot(snapshot, shape);
        error.maytrixRollbackSucceeded = true;
      } catch (rollbackError) {
        error.maytrixRollbackSucceeded = false;
        error.maytrixRollbackMessage = String(rollbackError && rollbackError.message || rollbackError);
      }
      throw error;
    }
  }

  function applySignaturePresentation() {
    if (!onTargetProduct()) return;

    var sizeMode = document.querySelector('[data-category-id="' + SIZE_MODE_CATEGORY_ID + '"]');
    var presetOption = sizeMode && sizeMode.querySelector('[data-option-id="' + PRESET_OPTION_ID + '"]');
    var presetLabel = directLabel(presetOption);
    if (presetLabel && presetLabel.textContent.trim() !== 'Signature Sizes') {
      presetLabel.textContent = 'Signature Sizes';
    }

    PRESET_CATEGORY_IDS.forEach(function (categoryId) {
      var category = document.querySelector('[data-category-id="' + categoryId + '"]');
      if (!category) return;
      var looseSelection = category.querySelector(':scope > .cpb-category-selected-choice');
      if (looseSelection) looseSelection.setAttribute('aria-hidden', 'true');

    });
  }

  var queued = false;
  function queueApply() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      applySignaturePresentation();
    });
  }

  function start() {
    queueApply();
    var root = document.getElementById('product-builder') || document.body;
    new MutationObserver(queueApply).observe(root, { childList: true, subtree: true });
    document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', queueApply);
    document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', queueApply);
  }

  window.__MAYTRIX_SIGNATURE_SIZES__ = Object.freeze({
    version: VERSION,
    getChoices: getChoices,
    getSelection: getSelection,
    commit: commit
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
}());
